export const enum CookieParameter {
  PairsDelimiter = '; ',
  KeyValueDelimiter = '=',
  MaxAge = 'Max-Age',
  Path = 'Path',
  Domain = 'Domain',
}
export const ACTIVITY_INTERVAL = 15 * 1000; // 15 seconds
export const VISIT_DURATION = 30 * (60 * 1000); // 30 minutes
